import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionMarkCircleFillMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.6 11.9999C21.6 17.3018 17.302 21.5999 12 21.5999C6.69809 21.5999 2.40002 17.3018 2.40002 11.9999C2.40002 6.69797 6.69809 2.3999 12 2.3999C17.302 2.3999 21.6 6.69797 21.6 11.9999ZM10.7272 8.32708C10.3758 8.67855 9.80591 8.67855 9.45444 8.32708C9.10297 7.97561 9.10297 7.40576 9.45444 7.05429C10.8603 5.6484 13.1397 5.6484 14.5456 7.05429C15.9515 8.46017 15.9515 10.7396 14.5456 12.1455C14.0746 12.6164 13.5034 12.9307 12.9 13.086V13.4999C12.9 13.9969 12.4971 14.3999 12 14.3999C11.503 14.3999 11.1 13.9969 11.1 13.4999V12.8999C11.1 12.0355 11.784 11.4938 12.3976 11.3558C12.7179 11.2837 13.0219 11.1235 13.2728 10.8727C13.9758 10.1697 13.9758 9.03002 13.2728 8.32708C12.5699 7.62414 11.4302 7.62414 10.7272 8.32708ZM12 17.9999C12.6628 17.9999 13.2 17.4626 13.2 16.7999C13.2 16.1372 12.6628 15.5999 12 15.5999C11.3373 15.5999 10.8 16.1372 10.8 16.7999C10.8 17.4626 11.3373 17.9999 12 17.9999Z",
		fill: "currentcolor"
	})]
});
export default SvgQuestionMarkCircleFillMini;
